import { render, staticRenderFns } from "./ExtensionSupport.vue?vue&type=template&id=711b8c1b&"
import script from "./ExtensionSupport.vue?vue&type=script&lang=js&"
export * from "./ExtensionSupport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports